
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Dance Competition</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm summer-camp section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Melvin <span >Louise</span></h2>
        </div>
        <div class="row text-justify">
            <div class="col-md-8">
                <p>Melvin Louis is an Indian Dancer &amp; Choreographer whose versatile dancing style has helped him
                    gather a large audience, especially on Instagram where he has more than 2 million followers. Melvin
                    has a self- titled YouTube channel with more than 3.66 million subscribers. Melvin’s dancing career
                    started after he appeared on the popular dance reality show ‘Dance India Dance in 2009 exposed on
                    Zee TV. Melvin plays a unique way of dancing styles called Krump-hop, Bolly Swag &amp; various other
                    dance forms have gained him a huge fan following and today he has three Dance Academy in Mumbai.</p>
                <p>Through his hard work, Melvin Louis has made him a successful &amp; popular dancer, choreographer
                    &amp; social media influencer in India and all over the world.</p>
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Dace Forms for Workshop</h4>
                </div>
                <p>Bollywood &amp; Free Style</p>
                <div class="text-justify">
                    <p><b>Let’s meet you then.</b></p>
                    <p><b>Performer – Melvin Louise</b></p>
                    <p><b>Dance Form: Bollywood &amp; Free Style </b></p>
                    <p><b>Date – 28<sup>th</sup> Aug 2022, Sunday </b></p>
                    <p><b>Time – 1.00 PM (Reporting at 12.00 PM)</b></p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="image-effect-2">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/melvin-louis.jpg"
                        alt="Melvin Louise" class="w-100">
                </div>
            </div>
        </div>
    </div>
</section>
